import React from 'react';
import PropTypes from 'prop-types';
import { filter } from 'ramda';
import { Row, Col } from 'react-flexbox-grid';

import ListItem from './ListItem';

const ContactInfoList = ({ editing, input, type, localeMessage }) => {
  const [value, setValue] = React.useState('');

  const thisData = input.value && Array.isArray(input.value) ? filter(d => d.contactType === type, input.value) : [];

  const onChange = event => {
    if (thisData) {
      const newField = { userId: thisData[0].userId, contactValue: event.currentTarget.value, contactType: type };
      const legitNewList = JSON.parse(JSON.stringify(input.value));
      legitNewList[legitNewList.findIndex(v => v.contactType === type)] = newField;
      setValue(event.currentTarget.value);
      input.onChange(legitNewList);
    }
  };

  const initialize = () => {
    // Just add some id so we can edit it. Patient service will assign a proper one
    if (editing) {
      const newInfo = { contactType: type, contactValue: type === 'sms' ? '' : [''], userId: Date.now() };
      input.onChange([...input.value, newInfo]);
    }
  };

  // Match value with thisData
  React.useEffect(
    () => {
      if (Array.isArray(thisData) && thisData.length > 0 && thisData[0].contactValue !== value) {
        setValue(thisData[0].contactValue || '');
      }
      if (Array.isArray(thisData) && thisData.length === 0) {
        setValue('');
      }
    },
    [thisData]
  );

  // Trigger initalize
  React.useEffect(
    () => {
      if (!Array.isArray(thisData) || thisData.length === 0) initialize();
    },
    [input.value]
  );

  return (
    <Row>
      <Col xs={8} sm={8} md={8} lg={8}>
        <Row>
          <Col xs={6} sm={6} md={6} lg={6}>
            <ListItem
              value={Array.isArray(value) ? value[0] : value}
              // Disable editing for data that came from the server (id is uuid, whereas new items have timestamp)
              editing={editing}
              onChange={onChange}
              textPlaceholder={'+358401234567'}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

ContactInfoList.propTypes = {
  editing: PropTypes.bool,
  input: PropTypes.object,
  type: PropTypes.string,
  localeMessage: PropTypes.func
};

export default ContactInfoList;
